import { WebEditorPropertiesView } from '@adornis/web-editor/client/legacy/EditorProperties.js';
import { renderTestimonialLayoutControls } from './editorTestimonialLayoutControls.js';
export class LandingEditorPropertiesView extends WebEditorPropertiesView {
  constructor(context: Record<string, any>) { super(context, { renderTestimonialLayoutControls }); }
}
